import React from "react";
import { celebrity } from "../fixtures/celebrity";
import Layout, { Main } from "../Layout";
import {
  Card,
  CardText,
  CardTitle,
  Col,
  Row,
  Button,
  Alert,
  Badge,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useAsync } from "react-use";
import { useApi } from "../Api/ApiContext";
import useCelebritiesStore from "../store/CelebritiesStore";

const Home = ({ orders, me }) => {
  const { getBalance } = useApi();
  const { error, loading, value: balance } = useAsync(getBalance);
  const { celebrities } = useCelebritiesStore();

  return (
    <Layout celebrities={celebrities.items}>
      <Main>
        <Row className={"mb-3 gap-3 gap-md-0"}>
          <Col sm={4}>
            <Card body className="my-2 h-100 justify-content-between">
              <CardTitle tag="h5">Vos produits</CardTitle>
              <CardText>
                {me.products.length === 0 ? (
                  <Alert color={"info"}>
                    Vous n'avez ajouté aucun produit à votre compte
                  </Alert>
                ) : (
                  <div>
                    Nombre de produit :{" "}
                    <Badge color="danger" pill>
                      {me.products.length}
                    </Badge>
                  </div>
                )}
              </CardText>

              <Button tag={Link} to={"/admin/products"} color="primary">
                {me.products.length === 0
                  ? "Ajouter un produit"
                  : "Voir les produits"}
              </Button>
            </Card>
          </Col>
          <Col sm={4}>
            <Card body className="my-2 h-100 justify-content-between">
              <CardTitle tag="h5">Votre portefeuille</CardTitle>
              {loading ? (
                <Row>
                  <Col lg={2} className={"mx-auto"}>
                    <Spinner color={"danger"} />
                  </Col>
                </Row>
              ) : error ? (
                <Alert color={"danger"}>
                  Une erreur nous empêche d'afficher cette information.
                </Alert>
              ) : (
                <>
                  <CardText>
                    <p>
                      Montant total : {balance.totalAmount}{" "}
                      {balance.userCurrency.toUpperCase()}
                      {balance.totalAmount > 0 ? "s" : ""}
                    </p>
                    <p>
                      Commission : {balance.charge}{" "}
                      {balance.userCurrency.toUpperCase()}
                      {balance.charge > 0 ? "s" : ""}
                    </p>
                    <p>
                      Montant net à payer : {balance.amountToPay}{" "}
                      {balance.userCurrency.toUpperCase()}
                      {balance.amountToPay > 0 ? "s" : ""}
                    </p>
                  </CardText>
                  <Button
                    tag={Link}
                    to={"/admin/balance"}
                    state={{ balance: balance }}
                    color="primary"
                  >
                    Voir le detail
                  </Button>
                </>
              )}
            </Card>
          </Col>
          <Col sm={4}>
            <Card body className="my-2 h-100 justify-content-between">
              <CardTitle tag="h5">Commandes reçues</CardTitle>
              <CardText>
                <p>
                  Commandes en attente :{" "}
                  <Badge color={"danger"} pill>
                    {
                      orders?.filter((o) => o.deliveryStatus === "in_progress")
                        .length
                    }
                  </Badge>
                </p>
                <p>
                  Total des commandes livrées:{" "}
                  <Badge color={"success"} pill>
                    {
                      orders?.filter((o) => o.deliveryStatus === "delivered")
                        .length
                    }
                  </Badge>
                </p>
              </CardText>
              <Button tag={Link} to={"/admin/orders"} color="primary">
                Voir les commandes
              </Button>
            </Card>
          </Col>
        </Row>
        <Row className={"gap-3 gap-md-0"}>
          <Col sm={4}>
            <Card body className="my-2 h-100 justify-content-between">
              <CardTitle tag="h5">Historique des paiements reçus</CardTitle>
              <CardText>
                <p>
                  Trouvez l'historique des paiements que vous avez reçus et les
                  détails de chaque paiement.
                </p>
              </CardText>
              <Button tag={Link} to={"/admin/payments"} color="primary">
                Voir les paiements
              </Button>
            </Card>
          </Col>
        </Row>
      </Main>
    </Layout>
  );
};

export default Home;
